import { render, staticRenderFns } from "./InputCurrency.vue?vue&type=template&id=b58fc280&scoped=true"
import script from "./InputCurrency.vue?vue&type=script&lang=js"
export * from "./InputCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58fc280",
  null
  
)

export default component.exports